import { render, staticRenderFns } from "./wb-widget-define.vue?vue&type=template&id=377814e6&scoped=true"
import script from "./wb-widget-define.vue?vue&type=script&lang=js"
export * from "./wb-widget-define.vue?vue&type=script&lang=js"
import style0 from "./wb-widget-define.vue?vue&type=style&index=0&id=377814e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377814e6",
  null
  
)

export default component.exports